// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"Jf90UrbpYaTwMiVstKkpO"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from '@sentry/nextjs'

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN

Sentry.init({
    enabled: true,
    dsn:
        SENTRY_DSN ||
        'https://65e5835a11d41a4aef3a22cbdf1b9a57@sentry.reserveit.co.za/2',
    // Adjust this value in production, or use tracesSampler for greater control
    environment: process.env.NEXT_PUBLIC_ENVIRONMENT ?? 'development',
    // ...
    // Note: if you want to override the automatic release value, do not set a
    // `release` value here - use the environment variable `SENTRY_RELEASE`, so
    // that it will also get attached to your source maps

    // Called for transaction events
    beforeSendTransaction(event) {
        // Modify or drop the event here
        if (
            event.transaction === '/api/healthz' ||
            event.transaction === '/api/prometheus'
        ) {
            // Don't send the event to Sentry
            return null
        }
        return event
    },

    tracesSampler: (samplingContext) => {
        if (
            samplingContext?.transactionContext?.name === 'GET /api/healthz' ||
            samplingContext?.transactionContext?.name === 'GET /api/prometheus'
        ) {
            return false
        }
        return 1.0
    },
    profilesSampleRate: 0.3,

    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.3,
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 0.5,

    integrations: [
        Sentry.replayIntegration(),
        Sentry.browserTracingIntegration(),
    ],

    // This option is required for capturing headers and cookies.
    sendDefaultPii: false,
})
